import { useMutation } from "@tanstack/react-query";
import axios, { type AxiosResponse } from "axios";

import env from "src/config/env";
import { getFromLocalStorage } from "src/lib/utils";

/**
 * Downloads an invoice PDF and saves it. This one call bypasses the shared instance:
 * its response interceptor unwraps to `response.data`, which would lose the blob's
 * response metadata, and the download needs the raw response.
 */
export const useDownloadInvoiceMutation = () =>
	useMutation({
		mutationFn: (uuid: string): Promise<AxiosResponse<Blob>> => {
			const access_token = getFromLocalStorage<string>("access_token");

			return axios.get<Blob>(`${env.REACT_APP_API_BASE_URL}/invoices/${uuid}/download`, {
				headers: { Authorization: `Bearer ${access_token}` },
				responseType: "blob",
			});
		},
		onSuccess: (response, uuid) => {
			const blob = new Blob([response.data]);
			const url = window.URL.createObjectURL(blob);

			const link = document.createElement("a");
			link.href = url;
			link.setAttribute("download", `Invoice_${uuid}.pdf`);

			document.body.appendChild(link);
			link.click();
			link.remove();

			window.URL.revokeObjectURL(url);
		},
	});
